import { render, staticRenderFns } from "./alert-box.vue?vue&type=template&id=995c1ca4&"
import script from "./alert-box.vue?vue&type=script&lang=ts&"
export * from "./alert-box.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports